<template>
  <div class="body-container">
    <div class="progress-box-insight">
      <div class="header-title d-flex justify-content-between px-3">
        <div>
          <router-link :to="{ name: 'participants-portal-dashboard' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="11.5" height="20" fill="none" viewBox="0 0 15 25">
              <path fill="var(--primary)" fill-rule="evenodd" d="M14.773 2.344L12.43 0 0 12.43l12.43 12.43 2.343-2.345L4.688 12.43 14.773 2.344z" clip-rule="evenodd" />
            </svg>
          </router-link>
        </div>
        <div class="col-10 col-md-10 text-center">
          <h3 class="title">Response Insights</h3>
        </div>
        <div></div>
      </div>
    </div>

    <div class="subtitle text-center">
      <p class="subtitle-text">
        View how your responses compare to others in charts below.
      </p>
    </div>

    <div class="content-wrapper" v-if="dataSources && dataSources.length > 0">
      <div v-for="(item, index) in dataSources" :key="item.surveyOrder" class="component-wrapper">
        <div v-if="item.chartType === 'HorizontalBarChart'">
          <HorizontalBarChartCard :index="index" :title="item.surveyQuestion" :dataParticipantName="dataParticipantName" :dataSources="item.milestone" :isLoaded="dataLoaded && dataLoaded.analyticsInsight" :primaryColor="globalElement.primaryColor || '#d8d8d8'" />
        </div>
        <div v-else-if="item.chartType === 'PieChart'">
          <PieChartCard :index="index" :title="item.surveyQuestion" :dataParticipantName="dataParticipantName" :dataSources="item.milestone" :isLoaded="dataLoaded && dataLoaded.analyticsInsight" :primaryColor="globalElement.primaryColor || '#d8d8d8'" />
        </div>
        <div v-else-if="item.chartType === 'VerticalBarChart'">
          <VerticalBarChartCard :index="index" :title="item.surveyQuestion" :dataParticipantName="dataParticipantName" :dataSources="item.milestone" :isLoaded="dataLoaded && dataLoaded.analyticsInsight" :primaryColor="globalElement.primaryColor || '#d8d8d8'" />
        </div>
        <div v-else-if="item.chartType === 'WordCloud'">
          <WordCloud :index="index" :title="item.surveyQuestion" :dataParticipantName="dataParticipantName" :dataSources="item.milestone" :isLoaded="dataLoaded && dataLoaded.analyticsInsight" :primaryColor="globalElement.primaryColor || '#d8d8d8'" />
        </div>
        <div v-else-if="item.chartType === 'LineChart'">
          <LineChartCard :index="index" :title="item.surveyQuestion" :dataParticipantName="dataParticipantName" :dataSources="item.milestone" :isLoaded="dataLoaded && dataLoaded.analyticsInsight" :primaryColor="globalElement.primaryColor || '#d8d8d8'" />
        </div>
        <div v-else-if="item.chartType === 'ScatterChart'">
          <ScatterChartCard :index="index" :title="item.surveyQuestion" :dataParticipantName="dataParticipantName" :dataSources="item.milestone" :isLoaded="dataLoaded && dataLoaded.analyticsInsight" :primaryColor="globalElement.primaryColor || '#d8d8d8'" />
        </div>
      </div>
      <div class="add-bottom-margin"></div>
    </div>
    <div class="card-container m-5" v-else-if="dataLoaded.analyticsInsight == false">
      <div class="no-data-in">
        <span class="no-data-in-text">No Data In</span>
      </div>
    </div>
  </div>
</template>

<script>
import HorizontalBarChartCard from "./components/containers/horizontal-bar-chart-card";
import LineChartCard from "./components/containers/line-chart-card.vue";
import PieChartCard from "./components/containers/pie-chart-card";
import VerticalBarChartCard from "./components/containers/vertical-bar-chart-card";
import ScatterChartCard from "./components/containers/scatter-chart-card";
import WordCloud from "./components/containers/word-cloud";
import _ from "lodash";

export default {
  name: "dashboard",
  data() {
    return {
      dataSources: [],
      dataLoaded: {},
      dataParticipantName: "Me"
    };
  },
  components: {
    HorizontalBarChartCard,
    LineChartCard,
    PieChartCard,
    VerticalBarChartCard,
    ScatterChartCard,
    WordCloud
  },
  methods: {
    async getAnalyticInsight() {
      const params = {};
      let result = [];
      let participantName = "";

      params["studyId"] = this.user.studyId;
      params["participantId"] = this.user.pid;

      const data = await this.$api.getPatientAnalyticsInsight(params);
      const isOk = _.get(data, "ok", false);

      if (isOk) {
        result = _.get(data, "body.data.surveys", []);
        participantName = data.body.data.participantName ? data.body.data.participantName : "";
      }

      return { result, participantName };
    },
    checkIfResultGenerated(params) {
      let count = 0;
      return new Promise(async (resolve, reject) => {
        count++;
        const apiCall = params => {
          this.$api
            .getPatientAsyncAnalyticsInsight(params)
            .then(res => {
              if (res.data.meta.status == 200) {
                resolve(res);
              } else {
                reject();
              }
            })
            .catch(err => {
              if (err.data && err.data.meta && err.data.meta.status == 404) {
                const seconds = 15000;
                if (count * seconds < 90000) {
                  setTimeout(() => {
                    apiCall(params);
                  }, seconds);
                } else {
                  reject("Timeout");
                }
              } else {
                reject(err);
              }
            });
        };
        apiCall(params);
      });
    },
    initAsyncAnalyticsDataGeneration() {
      return new Promise((resolve, reject) => {
        this.$api
          .initPatientAsyncInsight({
            studyId: this.user.studyId,
            participantId: this.user.pid
          })
          .then(res => {
            const processId = res.data.data.id;
            this.checkIfResultGenerated({
              studyId: this.user.studyId,
              processId: processId,
              participantId: this.user.pid
            })
              .then(res => {
                resolve({
                  result: res.data.data.surveys,
                  participantName: res.data.data.participantName
                });
              })
              .catch(reject);
          });
      });
    },
    turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    }
  },
  computed: {
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    user() {
      return this.$store.getters.participant;
    },
    globalElement() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    lang() {
      return this.globalElement && this.globalElement.language && this.globalElement.language.language_culture ? this.globalElement.language.language_culture : "en";
    }
  },
  async mounted() {
    this.$router.push({ query: { automatic_off_loader: false } });
    this.initAsyncAnalyticsDataGeneration()
      .then(response => {
        const user = this.user;
        if (user && user.participantMeta && user.participantMeta.firstName) {
          this.dataParticipantName = user.participantMeta.firstName;
        }
        this.dataSources = response.result;
        if (this.dataSources && this.dataSources.length > 0) {
          this.dataLoaded["analyticsInsight"] = true;
        } else {
          this.dataLoaded["analyticsInsight"] = false;
        }
        this.turnOffGlobalLoader();
      })
      .catch(err => {
        this.$toastr.error(err.message);
      });
  }
};
</script>

<style>
.body-container {
  border: solid 1px #d8e3e7;
}

.progress-box-insight {
  width: 100%;
  height: auto;
  border-bottom: solid 1px #d8e3e7;
}

.header-title {
  padding: 22px 0;
  margin: 0;
  background-color: #f3f3f4;
}

.text-center {
  text-align: center;
}

.title {
  font-family: "Roboto-medium";
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 22px;
  font-size: 24px;
  margin-bottom: 0;
}

.subtitle {
  padding: 12px 0;
}

.subtitle .subtitle-text {
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
  margin: 0;
}

.content-wrapper {
  padding: 10px 15px;
}

.content-wrapper .add-bottom-margin {
  margin-bottom: 100px;
}

.component-wrapper {
  margin-bottom: 16px;
}

.component-wrapper:last-child {
  margin-bottom: 0;
}
</style>
